import React, { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import theme from '../../styles/theme'
import '../../styles/fonts/font-family.css'
import GVStepper from '../../components/gov-br/stepper'
import Header from '../../components/gov-br/header';
import Footer from '../../components/gov-br/footer'
import IconBreadcrumbs from '../../components/gov-br/breadcrumbs';
import CookiesBanner from '../../components/gov-br/cookiebar';
import { Box, Card, CardContent, Stack } from '@mui/material';
import ReCAPTCHA from "react-google-recaptcha";
import GVButton from '../../components/gov-br/button';
import { FormProvider, useForm } from 'react-hook-form';
import StepGeneralInfo from './components/step-general-info';
import { isNumberAndGreaterThanZero } from '../../utils/numberUtils';

const AlterAccountEmailTest = () => {
  const methods = useForm();
  const [startForm, setStartForm] = useState(false)

  const onSubmit = () => {
    console.log('Formulário enviado com sucesso!');
  };

  const autocompleteOptions = [
    { label: 'Opção 1', value: 'option1' },
    { label: 'Opção 2', value: 'option2' },
  ];

  const appTheme = createTheme({
    palette: {
      mode: 'light',
    },
  });

  const onChangeCaptcha = (value) => {
    console.log("Captcha value:", value);
  }

  const handleStart = (e) => {
    e.preventDefault()
    setStartForm(true)
  }

  const handleBackToStart = () => {
    setStartForm(false)
  }

  const TestStep2Condition1Component = () => {
    return(<React.Fragment>Step 2 - Dados pessoais: Teste condição 1</React.Fragment>)
  }

  const TestStep2Condition2Component = () => {
    return(<React.Fragment>Step 2 - Dados pessoais: Teste condição 2</React.Fragment>)
  }

  const TestStep2Condition3Component = () => {
    return(<React.Fragment>Step 2 - Dados pessoais: Teste condição 3</React.Fragment>)
  }

  const TestStep3Component = () => {
    return(<React.Fragment>Step 3: Leitura do rosto</React.Fragment>)
  }

  const TestStep4Component = () => {
    return(<React.Fragment>Step 4: Leitura do documento</React.Fragment>)
  }

  const TestStep5Component = () => {
    return(<React.Fragment>Step 5: Enviar</React.Fragment>)
  }

  const steps = [
    {
      label: 'Informações gerais',
      components: [
        {
          component: StepGeneralInfo,
          condition: () => true,
          completeCondition: (formValues) => {
            if(!isNumberAndGreaterThanZero(formValues.reason))
              methods.setError('reason', { type: 'manual', message: 'Uma opção deve ser selecionada para avançar' })
            else
              methods.clearErrors('reason')

            if(!isNumberAndGreaterThanZero(formValues.solicitation))
              methods.setError('solicitation', { type: 'manual', message: 'Uma opção deve ser selecionada para avançar' })
            else
              methods.clearErrors('solicitation')

            return isNumberAndGreaterThanZero(formValues.reason) && isNumberAndGreaterThanZero(formValues.solicitation)
          }
        }
      ],
    },
    {
      label: 'Dados pessoais',
      components: [
        {
          component: TestStep2Condition1Component,
          condition: (formValues) => formValues.solicitation === '1',
          completeCondition: () => true
        },
        {
          component: TestStep2Condition2Component,
          condition: (formValues) => formValues.solicitation === '2',
          completeCondition: () => 1 == 2
        },
        {
          component: TestStep2Condition3Component,
          condition: (formValues) => formValues.solicitation === '3',
          completeCondition: () => true
        },
      ],
    },
    {
      label: 'Leitura do rosto',
      components: [
        {
          component: TestStep3Component,
          condition: () => true,
          completeCondition: () => true
        }
      ]
    },
    {
      label: 'Leitura do documento',
      components: [
        {
          component: TestStep4Component,
          condition: () => true,
          completeCondition: () => true
        }
      ]
    },
    {
      label: 'Enviar',
      components: [
        {
          component: TestStep5Component,
          condition: () => true,
          completeCondition: () => true
        }
      ]
    }
  ];

  return (
      <div style={{
        display: 'flex',
        minWidth: '100vh',
        flexDirection: 'column',
        height: '100vh'
       }}>
        <CssBaseline />
        <Header />
        <Container maxWidth="xl" sx={{
          marginTop: 'var(--spacing-scale-3x)!important',
          maxWidth: '100%!important',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
          }}>
          <IconBreadcrumbs actualPage="Alterar e-mail na conta gov.br" />
          {!startForm && <main className='main-content' style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', marginBottom: 'var(--spacing-scale-2x)' }}>
            <div>
                <h1 style={{ margin: 0 }}>Formulário de atendimento</h1>
              <h2 style={{ margin: 0, marginBottom: '1em' }}>Alterar e-mail da conta gov.br</h2>
            </div>
            <div style={{ flexGrow: 1, display: 'flex', marginBottom: 'var(--spacing-scale-2x)' }}>
              <Card sx={{ flexGrow: 1 }}
                elevation={2}>
                <CardContent sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                }}>
                  <div style={{ flexGrow: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div>
                        <p style={{ maxWidth: '80%' }}>Você não tem acesso ás opções de <strong>recuperação de senha</strong> disponíveis na conta gov.br?</p>
                        <p style={{ maxWidth: '90%' }}>Não se preocupe! Vamos te ajudar, mas antes precisamos <strong>confirmar a sua identidade</strong> através do envio de algumas imagens do seu rosto e documento.</p>
                        <p style={{ maxWidth: '100%' }}>Esta verificação é necessária para <strong>evitar fraudes e garantir a segurança</strong> no uso da conta gov.br para todos os cidadãos!</p>
                      </div>
                      <div style={{
                        marginTop: 'var(--spacing-scale-3x)',
                        marginRight: 'var(--spacing-scale-3x)',
                        }}>
                        <img
                          src="data:image/png;base64,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" 
                          alt="logo"/>
                      </div>
                    </div>
                    <ReCAPTCHA
                      sitekey="Your client site key"
                      onChange={onChangeCaptcha} />
                  </div>
                  <div>
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      justifyContent="space-between"
                      gap={2}
                      sx={{
                        position: 'relative',
                        bottom: 0,
                        left: 0,
                        right: 0
                      }}
                    >
                      <Box
                        sx={{
                          flexShrink: 1,
                          alignSelf: { xs: 'flex-start', sm: 'center' },
                        }}
                      >
                      <GVButton size="small" label="Voltar ao login gov.br" />
                      </Box>
                      <Stack
                        gap={2}
                        direction={{
                          xs: 'row-reverse',
                          sm: 'row',
                        }}
                        sx={{
                          flexShrink: 0,
                          alignSelf: { xs: 'flex-end', sm: 'center' },
                        }}
                      >
                        <GVButton size="small"  variant="contained" label="Iniciar"
                        color="success"
                        sx={{
                          marginRight: 'var(--spacing-scale-7x)',
                          backgroundColor: 'var(--green-cool-vivid-50)!important',
                          border: 'var(--surface-white-border-solid-lg)!important'
                        }}
                        onClick={handleStart} />
                      </Stack>
                    </Stack>
                  </div>
                </CardContent>
              </Card>
            </div>
          </main>}
          {startForm && <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <GVStepper formSubmit={methods.handleSubmit} steps={steps} handleBack={handleBackToStart} />
            </form>
          </FormProvider>}
        </Container>
        <CookiesBanner />
        <Footer/>
      </div>
  );
};

export default AlterAccountEmailTest;